import { render } from "./CompanyModal2.vue?vue&type=template&id=7de82eb6&scoped=true&ts=true"
import script from "./CompanyModal2.vue?vue&type=script&lang=ts"
export * from "./CompanyModal2.vue?vue&type=script&lang=ts"

import "./CompanyModal2.vue?vue&type=style&index=0&id=7de82eb6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de82eb6"]])

export default __exports__